import React, { Component, Fragment } from 'react'

import { ChevronThinRight } from '../../components/Icons'
import { NoticeContainer, Content, IconContainer } from './styles'

class Message extends Component {
  render() {
    const { message } = this.props

    return (
      <Fragment>
        {message.excerpt.rendered.includes('http') ? (
          <a href={message.excerpt.rendered.replace(/<[^>]*>?/gm, '')} target="_blank" rel="noopener noreferrer">
            <NoticeContainer>
              <Content>
                {message.title.rendered}
                {message.content.rendered !== '' ? (
                  <span>{message.content.rendered.replace(/<[^>]*>?/gm, '')}</span>  
                ) : null}
              </Content> 
              <IconContainer>
                <ChevronThinRight size="" />
              </IconContainer>
            </NoticeContainer>
          </a>
        ) : (
          <NoticeContainer noLink>
            <Content>
              {message.title.rendered}
              {message.content.rendered !== '' ? (
                <span>{message.content.rendered.replace(/<[^>]*>?/gm, '')}</span>  
              ) : null}
            </Content> 
          </NoticeContainer>
        )}
      </Fragment>
    )
  }
}

export default Message



// WEBPACK FOOTER //
// ./src/components/Message/index.js